import React from 'react';
import i18next from "i18next";
import { Controller, useFormContext } from "react-hook-form";
import {
    FormHelperText,
    MenuItem,
    Select
} from "@mui/material";
import { find, get as lodashGet } from "lodash";
import EAInputBloc from "../common/EAInputBloc";
import { EASelectChip } from "./EASelectChip";
import useStyles from "../../style/js-style/containers/administration/rules/RuleFormsStyle";
import EAColorIcon from '../common/EAColorIcon';

const RuleSelectInput = ({
    fieldName,
    isRequired = false,
    label = '',
    placeholder = '',
    options,
    onChange = () => { },
    validate = () => { return null },
    variant = 'standard', //mui variant
    labelVariant = 'standard', //standard, chip
    index,
    disableUnderline = false,
    customStyle = null,
    disabled = false,
    value = null
}) => {
    const { classes } = useStyles();
    const formMethods = useFormContext();
    const {
        control,
        formState: { errors },
        setValue,
        trigger,
        clearErrors,
    } = formMethods;

    return (
        <EAInputBloc label={label} customLabelStyle={{ fontSize: "14px" }} customChildStyle={{ marginTop: "0px" }} index={index}>
            <Controller
                control={control}
                name={fieldName}
                rules={{
                    validate: (value) => {
                        if (isRequired) {
                            const isEmpty = !value || value.length === 0;
                            if (isEmpty) {
                                return i18next.t("infos.required");
                            } else {
                                clearErrors(fieldName);
                            }
                        }

                        return validate(value);
                    }
                }}
                render={({ field }) => (
                    <Select
                        {...field}
                        value={value || formMethods.getValues(fieldName) || ""}
                        id={`${fieldName}-id`}
                        className={classes.select}
                        variant={variant}
                        fullWidth
                        disabled={disabled}
                        renderValue={(selected) => {
                            if (labelVariant === 'chip') {
                                return (
                                    <EASelectChip
                                        selected={selected}
                                        options={options}
                                        placeholder={placeholder}
                                        onDelete={() => setValue(fieldName, '')}
                                        disabled={disabled}
                                    />
                                );
                            } else {
                                if (selected === "") {
                                    return (
                                        <span className={classes.placeHolder}>
                                            {placeholder}
                                        </span>
                                    );
                                } else {
                                    let entry = find(options, { value: selected });

                                    return (
                                        <span>
                                            {
                                                entry?.icon && <EAColorIcon icon={entry.icon} svgStyle={{position: "relative", top: "3px", left: "-5px"}} width={"20px"} height={"20px"} />
                                            }
                                            <span style={{ color: "#2E2E3A", ...customStyle }}>
                                                {/* Nullish coalescing operator */}
                                                {entry?.label ?? selected}
                                            </span>
                                        </span>
                                    );
                                }
                            }
                        }}
                        error={!!lodashGet(errors, `${fieldName}`)}
                        onChange={(e) => {
                            setValue(fieldName, e.target.value);
                            onChange(e.target.value);
                            trigger(fieldName);
                        }}
                        displayEmpty
                        disableUnderline={disableUnderline}
                    >
                        <MenuItem disabled value="">
                            <span className={classes.placeHolder}>
                                {placeholder}
                            </span>
                        </MenuItem>

                        {options?.map((option, index) => (
                            <MenuItem key={`${option.value}-${index}`} value={option.value} disabled={option.isDisabled}>
                                {
                                    option?.icon &&
                                    <div className={classes.flexItemIcon}>
                                        <EAColorIcon icon={option.icon} width="20px" height="20px" svgStyle={{position: "relative", top: "1px", left: "2px"}}/>
                                    </div>
                                }
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                )}
            />

            {
                !!lodashGet(errors, `${fieldName}`) && (
                    <FormHelperText className="Mui-error">
                        {lodashGet(errors, `${fieldName}.message`)}
                    </FormHelperText>
                )
            }
        </EAInputBloc>
    );
}

export default RuleSelectInput;
